// extracted by mini-css-extract-plugin
export default {"component":"b1Hs7v","icon":"c1Hs7v"};